import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterOnlyNegativeFeedback = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterOnlyNegativeFeedback'),
);
